<!--
程序名：问题设计页面
功能：对问卷中问题的添加、编辑、删除
-->
<template>
    <div class="Design" v-loading="loading" element-loading-text="加载中...">
        <h3>{{ title }}</h3>
        <el-card class="box-card" v-for="(item, index) in detail" style="margin: 10px" :key="item.id">
            <div slot="header" class="clearfix">
                <div class="questionTitle">
                    <!--显示必填标识-->
                    <span style="color: #f56c6c">
                        <span v-if="item.must">*</span>
                        <span v-else>&nbsp;</span>
                    </span>
                    <span style="color: black; margin-right: 3px">{{ index + 1 + '.' }}</span>
                    {{ item.content }}
                </div>
                <div style="float: right" v-if="ReadOnly == false">
                    <el-button style="padding: 2px" type="4" @click="editorQuestion(item)">编辑</el-button>
                    <el-button style="padding: 2px; color: #f56c6c" type="text" @click="deleteQuestion(index)">删除</el-button>
                </div>
            </div>

            <!--单选题展示-->
            <div class="text item" v-if="item.select_type_enum == '2'" v-for="(option, index) in item.QuestionOptions" :key="option.id">
                                    <span style="color: red">
                        <span>#{{option && option.data_key}}</span>
                    </span>
                <el-radio v-model="item.options_value" :label="index" style="margin: 5px">{{ option.options_name }}</el-radio>
            </div>

            <!--多选题展示-->
            <!-- <el-checkbox-group >

        </el-checkbox-group> -->
            <div class="text item" v-if="item.select_type_enum == '1'" v-for="(option, index) in item.QuestionOptions" :key="option.id">
                                    <span style="color: red">
                        <span>#{{option && option.data_key}}</span>
                    </span>
                <el-checkbox :label="index" style="margin: 5px">{{ option.options_name }}</el-checkbox>
            </div>
            <!--填空题展示-->
            <div v-if="item.select_type_enum == '4'">
                                <span style="color: red">
                        <span>#{{item.QuestionOptions[0] && item.QuestionOptions[0].data_key}}</span>
                    </span>
            <el-input type="textarea" :rows="item.row" resize="none" v-model="item.options_value"> </el-input>
            </div>
            <!--填空题展示-->
            <div v-if="item.select_type_enum == '3'">
                                <span style="color: red">
                        <span>#{{item.QuestionOptions[0] && item.QuestionOptions[0].data_key}}</span>
                    </span>
            <el-input type="string" v-model="item.options_value"> </el-input>
            </div>
        </el-card>

        <el-button icon="el-icon-circle-plus" @click="addQuestion" style="margin-top: 10px" v-if="ReadOnly == false">添加题目</el-button>

        <br /><br /><br /><br /><br />

        <!--添加题目弹窗-->
        <el-dialog :title="dialogTitle" :visible.sync="dialogShow" :modal="false" width="60%" :close-on-click-modal="false">
            <el-form ref="form" class="scrollable-form" :model="willAddQuestion" label-width="80px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="题目标题" style="width: 100%">
                            <el-input v-model="willAddQuestion.content" placeholder="请输入标题"></el-input>
                            <!-- <el-input v-model="willAddQuestion.id" :value="willAddQuestion.id" placeholder="请输入标题" ></el-input> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="题目类型" style="width: 100%">
                            <el-select v-model="willAddQuestion.select_type_enum" placeholder="请选择题目类型" :disabled="willAddQuestion.isEdit" @change="typeChange" style="width: 100%">
                                <el-option v-for="item in allType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <template v-if="willAddQuestion.select_type_enum == '2' || willAddQuestion.select_type_enum == '1'">
                    <el-form-item :label="item.data_key" label-width="150px" :key="item.id" v-for="(item, index) in willAddQuestion.QuestionOptions">
                        <el-row>
                            <el-col :span="11">
                                <el-input v-model="item.options_name" placeholder="请输入选项名" style="width: 100%"></el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-button type="danger" plain class="" @click="deleteOption(index)">删除选项</el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </template>
                <template v-if="willAddQuestion.select_type_enum == '4' || willAddQuestion.select_type_enum == '5'">
                </template>
            </el-form>
            <br />
            <div style="width: 100%; text-align: right; margin-bottom: 20px">
                <el-button v-if="willAddQuestion.select_type_enum == '2' || willAddQuestion.select_type_enum == '1'" type="primary" plain class="addOptionButton" @click="addOption"
                    >新增选项</el-button
                >
                <el-button style="margin-left: 10px" @click="dialogShow = false">取消</el-button>
                <el-button type="primary" style="margin-left: 10px" @click="checkAddQuestion">完成</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default{
    props: {
        ReadOnly: { type: Boolean, default: false }
    },
    data() {
        return {
            currentQuestionId: 0, // 当前题目questionid
            currentOptionId: 0, // 当前选项id
            loading: false, // 页面加载中
            dialogShow: false,
            dialogTitle: ``,
            detail: [],
            wjId: 0,
            title: ``,
            desc: ``,
            willAddQuestion: {
                id: 0,
                dic_mobile_paper_id: 0,
                content: ``,
                select_type_enum: ``,
                display_order: 0,
                // type: ``,
                // title: ``,
                QuestionOptions: [
                    {
                        // title: ``, // 选项标题
                        id: 0, // 选项id
                        dic_mobile_paper_content_id: 0, // 题目id
                        options_name: ``, // 选项名称
                        options_value: ``, // 选项值
                        display_order: 0// 排序
                    }
                ],
                row: 1,
                must: false // 是否必填
            },
            allType: [
                {
                    value: 2,
                    label: `单选题`
                },
                {
                    value: 1,
                    label: `多选题`
                },
                {
                    value: 3,
                    label: `填空题`
                },
                {
                    value: 4,
                    label: `多行文本题`
                },
                {
                    value: 5,
                    label: `签名控件`
                }
            ]
        }
    },
    methods: {
        // 初始化问卷所有问题
        init(wjId, Name, desc, detail) {
            this.wjId = wjId
            this.title = Name
            this.desc = desc
            this.getQuestionList(detail)
        },
        // 获取问题列表(问卷内容)
        getQuestionList(detail) {
            this.detail = detail
            this.loading = false
        },
        // 点击添加问题按钮
        addQuestion() {
            if (this.wjId == 0 || this.wjId == null) {
                this.$message({
                    type: `error`,
                    message: `清先创建问卷!`
                })
                return
            }
            this.dialogTitle = `添加题目`
            // 当前问题
            this.currentQuestionId += 1
            // 当前选项
            this.currentOptionId += 1
            this.willAddQuestion = {
                id: this.currentQuestionId,
                dic_mobile_paper_id: this.wjId,
                content: ``,
                select_type_enum: ``,
                display_order: 0,
                // type: ``,
                // title: ``,
                QuestionOptions: [
                    {
                        // title: ``, // 选项标题
                        id: this.currentOptionId, // 选项id
                        dic_mobile_paper_content_id: this.currentQuestionId, // 题目id
                        options_name: ``, // 选项名称
                        options_value: ``, // 选项值
                        display_order: 0// 排序
                    }
                ],
                row: 1,
                must: false // 是否必填
            }
            this.dialogShow = true
        },
        // 删除问题
        deleteQuestion(index) {
            this.$confirm(`确定删除此题目?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                this.detail.splice(index, 1)
            })
        },
        // 确认添加/保存题目
        checkAddQuestion() {
            if (this.willAddQuestion.isEdit) {
                // TODO:从deatil中查询要修改的数据，重新赋值
                this.detail.forEach(item => {
                    if (item.id == this.willAddQuestion.id) {
                        item = this.willAddQuestion
                    }
                })
            } else {
                // 添加保存问题
                this.detail.push(this.willAddQuestion)
            }

            this.willAddQuestion = {
                id: 0,
                dic_mobile_paper_id: 0,
                content: ``,
                select_type_enum: ``,
                display_order: 0,
                // type: ``,
                // title: ``,
                QuestionOptions: [
                    {
                        // title: ``, // 选项标题
                        id: 0, // 选项id
                        dic_mobile_paper_content_id: 0, // 题目id
                        options_name: ``, // 选项名称
                        options_value: ``, // 选项值
                        display_order: 0// 排序
                    }
                ],
                row: 1,
                must: false // 是否必填
            }
            this.dialogShow = false
            this.$emit(`designData`, this.detail)
        },
        // 点击编辑问题按钮
        editorQuestion(item) {
            this.willAddQuestion = item
            this.willAddQuestion.isEdit = true
            this.dialogTitle = `编辑题目`
            this.dialogShow = true
        },
        // 添加选项
        addOption() {
            this.currentOptionId += 1
            this.currentQuestionId += 1
            this.willAddQuestion.QuestionOptions.push({
                // title: ``, // 选项标题
                id: this.currentOptionId, // 选项id
                dic_mobile_paper_content_id: this.currentQuestionId, // 题目id
                options_name: ``, // 选项名称
                options_value: ``, // 选项值
                display_order: 0// 排序
            })
        },
        // 删除选项
        deleteOption(index) {
            this.willAddQuestion.QuestionOptions.splice(index, 1)
        },
        // 切换问题类型
        typeChange(value) {
            console.log(value)
            this.willAddQuestion.select_type_enum = value
            this.willAddQuestion.QuestionOptions = [
                {

                    id: 0, // 选项id
                    dic_mobile_paper_content_id: 0, // 题目id
                    options_name: ``, // 选项名称
                    options_value: ``, // 选项值
                    display_order: 0// 排序
                }
            ]
            this.row = 1
        }
    }
}
</script>
<style scoped>
.Design {
}
.Design .dialog {
    text-align: left;
}
.Design .questionTitle {
    display: inline-block;
    width: 80%;
    font-size: 16px;
    color: #303133;
}
.Design .addOptionButton {
    display: inline-block;
    margin-left: 80px;
}
.box-card {
    width: 100%;
    text-align: left;
}
.Design .top {
    color: #606266;
    margin-left: 20px;
    padding: 0 10px 10px 10px;
    border-bottom: 3px solid #409eff;
    font-size: 15px;
    line-height: 22px;
    text-align: left;
}
.scrollable-form {
  height: 500px; /* 固定高度 */
  overflow-y: auto; /* 超出时显示垂直滚动条 */
  padding-right: 10px; /* 避免滚动条遮挡内容 */
}
</style>



// WEBPACK FOOTER //
// src/common/Design.vue